import React from "react";

import { ThemeProvider } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { CssBaseline } from "@mui/material";
import { createAppTheme } from "../customProject/theme";

export default function Layout(props) {
  const storedSettings = useSelector((state) => state.session.theme);
  const appTheme = React.useMemo(
    () => createAppTheme(storedSettings),
    [storedSettings]
  );

  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
}
